import { css, html } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import { LightTheme } from "../ThemeLight";
import "../SettingsControl/UserSettings";

import "@shoelace-style/shoelace/dist/components/dialog/dialog.js";
import "@shoelace-style/shoelace/dist/components/button/button.js";

@customElement("ds-profile-dialog")
export class ProfileDialog extends BaseElement {
    static override styles = [
        Style,
        LightTheme,
        css`
            :host {
                display: block;
            }
            sl-dialog::part(base) {
                color: black;
            }
        `,
    ];
    @property({ type: String }) propName: any;
    @query("#dialog") protected _dialog?: HTMLElement;

    override render() {
        return html`<sl-dialog id="dialog" label="My profile" open>
            <ds-user-settings-control
                @sl-hide=${(e: any) => e.stopPropagation()}
                @sl-after-hide=${(e: Event) => e.stopPropagation()}
            ></ds-user-settings-control>
            <div slot="footer">
                <sl-button variant="danger" @click=${() => this._raiseEvent("ds-delete-user")}
                    >Delete account</sl-button
                >
                <sl-button @click=${() => this._kernel.signOut()}>Sign out</sl-button>
                <sl-button @click=${() => (this._dialog as any)?.hide()}>Close</sl-button>
            </div>
        </sl-dialog>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-profile-dialog": ProfileDialog;
    }
}
